import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, XIcon } from 'lucide-react';
import { compras } from '../data/compras';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5000;
const HIDDEN_MS = 10000;
export function PurchaseNotifier() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % compras.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  if (dismissed) return null;
  const compra = compras[index];
  return <div className="pointer-events-none fixed bottom-[5.5rem] left-4 z-50 lg:bottom-6 lg:left-6" aria-live="polite" data-id="element-24" data-mp="qwz0k44bemdg">
      <AnimatePresence data-id="element-25" data-mp="o4jgc2lcs8bj">
        {visible ? <motion.div key={`${compra.name}-${index}`} initial={{
        opacity: 0,
        x: -48
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        y: 56
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl border border-gold bg-ink/95 p-4 shadow-glow backdrop-blur-[10px] sm:w-[21rem]" data-id="element-26" data-mp="j5yq8vztf50t">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-line" data-id="element-27" data-mp="dw7nf3m5enx">
              <CheckCircle2Icon className="h-4 w-4 text-gold" strokeWidth={2} aria-hidden="true" data-id="element-28" data-mp="3mmp05lyiq27s" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-29" data-mp="3iktxoe4upisf">
              <p className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-30" data-mp="3ikkb70j0ltrh">
                Compra confirmada
              </p>
              <p className="mt-1 text-[13px] font-semibold leading-snug text-ice" data-id="element-31" data-mp="33ymvlc8zzpvj">
                {compra.name} adquirió {compra.plan}
              </p>
              <p className="mt-1.5 flex items-center gap-1.5 text-[12px] text-cool" data-id="element-32" data-mp="381jhpcxqy448">
                <MapPinIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-33" data-mp="2u1iie1x4r4qv" />
                {compra.city} · hace {compra.minutesAgo} min
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} className="-mr-1 -mt-1 rounded-md p-1 text-cool transition-colors duration-200 ease-smooth hover:text-gold" aria-label="Cerrar notificaciones de compra" data-id="element-34" data-mp="3mocrk2ohyhp1">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="3cy9xs09jwzpn" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}